import React, { Component } from "react";
import FetchServerData from "../../../provider/FetchServerData";
import { PaymentSuccess_Url } from "../../../provider/ServiceUrl";
import PtsAlert from "../ptsAlert/PtsAlert";
import Button from "@mui/material/Button";

class PaypalPaymentSuccess extends Component {
  constructor(props) {
    super(props);
    let url = window.location.href;
    let urlObject = new URL(url);
    let searchParams = new URLSearchParams(urlObject.search);
    let urlTid = searchParams.get("t");
    let orderId = searchParams.get("o");
    let payerID = searchParams.get("PayerID");
    let subscriptionId = searchParams.get("subscription_id");
    let baToken = searchParams.get("ba_token");
    let token = searchParams.get("token");

    this.state = {
      urlTid: urlTid,
      orderId: orderId,
      payerID: payerID,
      subscriptionId: subscriptionId,
      baToken: baToken,
      token: token,
      render: false,
    };
    this.getPaymentSuccesDetails(
      urlTid,
      orderId,
      payerID,
      subscriptionId,
      baToken,
      token
    );
  }

  getPaymentSuccesDetails(
    urlTid,
    orderId,
    payerID,
    subscriptionId,
    baToken,
    token
  ) {
    const postObject = {
      header: { tid: urlTid },
      orderId: orderId,
      payerID: payerID,
      subscriptionId: subscriptionId,
      baToken: baToken,
      token: token,
    };
    FetchServerData.callPostService(PaymentSuccess_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          // let paypalPaymentDetails = output.data;
          this.setState({
            render: true,
          });
        } else {
        }
      })
      .catch((error) => {});
  }

  closePaymentSuccessWindow() {
    window.close();
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <div
          className="authentication-wrapper authentication-cover"
          style={{ padding: "10em 2em 4em 2em" }}
        >
          <div className="authentication-inner row m-0">
            <div className="row">
              <div className="col" style={{ textAlign: "center" }}>
                <div class="paymetsuccesscircle">
                  <div class="paymetsuccesscheckMark"></div>
                </div>
                <div className="confirmationCardHeading mt-4">
                  Transaction complement successfully
                </div>
                <p className="card-text">Thank you for your billing</p>
              </div>
              <div className="row mt-4 text-center">
                <div className="col-md-12 text-center">
                  <Button
                    style={{
                      background: "rgb(242, 109, 33)",
                      color: "rgb(255, 255, 255)",
                      borderBottom: "3px solid rgb(99, 98, 98)",
                      borderRadius: "5px",
                      width: "120px",
                      padding: "5px 10px",
                      textTransform: "capitalize",
                      fontWeight: "600",
                    }}
                    onClick={this.closePaymentSuccessWindow.bind(this)}
                  >
                    Ok
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default PaypalPaymentSuccess;
